<template>
  <div class="app">
    <headNavs />
    <router-view :key="$route.fullPath" />
    <foot />
  </div>
</template>
<script>
import '@/assets/css/common.css'
import headNavs from '@/component/headNavs.vue'
import foot from '@/component/foot.vue'
export default {
  components: { headNavs, foot },
  data() {
    return {}
  },
}
</script>
<style lang="less" scoped>
.app {
  width: 750px;
  height: 100%;
}
</style>
